<article class="block-default" [ngClass]="block.cssClass">
  <main class="block-default__inner container section-inset-b">
    <!-- <h2 *ngIf="block.title" [innerHTML]="block.title | highlight" class="splitting splitting--word-in" data-split></h2> -->

    <!-- items aanpasbaar in cms -->
    <ul *ngIf="block.contentBlockDefaultItems?.length">
      <li
        *ngFor="let item of block.contentBlockDefaultItems; let i = index; trackBy: trackByFn"
        class="block-default__item row scroll-trigger"
        [class.flex-row-reverse]="i % 2 === 0"
        [class.section-outset-y]="i !== 0 && i !== block.contentBlockDefaultItems!.length - 1"
        [class.section-inset-t]="i === 0"
        [id]="id(item)"
      >
        <div class="col-md-6 position-relative block-default__item__figure mb-5 mb-md-0">
          <fstr-image
            *ngIf="item.image?.url && !item.videoUrl"
            [image]="item.image"
            [class.skew-bg--secondary]="i % 2 !== 0"
            class="d-block position-relative z-index-2"
            [class.has--skew-bg]="!item.imageTransparent"
            [objectFitMode]="!item.imageTransparent"
            [imageSizes]="[250, 500, 800, 1200]"
            [width]="!item.imageTransparent ? 520 : 0"
            [height]="!item.imageTransparent ? 333 : 0"
            [alt]="item.image?.alt || item.title || 'block-image'"
          ></fstr-image>

          <div
            [ngClass]="i % 2 === 0 ? 'pull-e' : 'pull-s'"
            class="background-dots"
            *ngIf="!item.videoUrl && item.imageTransparent && item.image?.url && hasDarkTheme"
          ></div>

          <div *ngIf="item.videoUrl" class="has--skew-bg">
            <app-video [url]="item.videoUrl"></app-video>
          </div>
        </div>
        <div class="block-default__item__content col-md-5">
          <!-- activeScrollTrigger?.includes(id(item)) -->
          <!--<h2 class="block-default__item__title" [innerHTML]="item.title | highlight : 'font-display text-primary-gradient'"></h2>-->

          <h2
            class="block-default__item__title splitting splitting--word-in"
            *ngIf="item.title"
            [innerHTML]="item.title | highlight : 'font-display text-primary-gradient'"
            data-split
          ></h2>

          <div
            class="markdown-content mb-0 anim-fade-up delay--1"
            [innerHTML]="item.text || '' | resizeHtmlImages | stripEmbed : cookiePreferences | safe"
          ></div>
          <fstr-link
            class="d-block anim-fade-up delay--3"
            *ngIf="item.button?.url || item.button?.routerLink"
            [button]="item.button!"
            [cssClasses]="'button button--primary-gradient has--dot'"
          >
            <em *ngIf="!item.button.text">{{ 'lees-meer' | fromDictionary }}</em>
          </fstr-link>
        </div>
      </li>
    </ul>
  </main>

  <app-big-text
    *ngIf="block.payoff"
    class="block-default__payoff text-light"
    [text]="block.payoff"
    [speed]="1.01"
    [splitLines]="true"
  ></app-big-text>
</article>
